/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .component('subItem', {
    templateUrl: 'app/components/offers/list/item/SubItem.html',
    controller: SubItem,
    bindings: {
      availability: '<',
      groupId: '<',
      rateplan: '<',
      addons: '<',
      parent: '<',
      personsCount: '<',
      onSave: '&'
    }
  });

/** @ngInject */
// eslint-disable-next-line
function SubItem(Currency, $uibModal, ENV, Params, $translate, ConfigBookingEngine) {
  var $this = this;
  $this.Currency = Currency;
  $this.Params = Params;
  $this.occupancy = $this.Params.getOccupancy();
  $this.$translate = $translate;
  $this.$uibModal = $uibModal;
  $this.ENV = ENV;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.selectedDorms = 0;
}

SubItem.prototype = {
  $onInit: function () {
    this.viewType = this.Params.getViewType();
    this.attributes = this.getAttributes();
    var checkIn = this.Params.getCheckIn();
    var checkOut = this.Params.getCheckOut();
    this.lengthOfStay = moment(checkOut).diff(checkIn, 'days');
    this.showRateplanAvailability = this.ConfigBookingEngine.showRateplanAvailability();
  },

  getAvailability: function () {
    if (this.viewType === 'rates') {
      return this.rateplan.availableUnits;
    } else {
      return this.availability;
    }
  },

  hasAvailability: function () {
    return this.getAvailability() > 0;
  },

  handleSave: function () {
    if (this.isEnabledHostelView()) {
      for (var i = 0; i < this.selectedDorms; i++) {
        this.onSave({ rateplan: this.rateplan });
      }
    } else {
      this.onSave({ rateplan: this.rateplan });
    }
  },

  getName: function () {
    return this.rateplan.name;
  },

  getDescription: function () {
    return this.rateplan.description;
  },

  findRoomPrice: function(){
    return this.parent.allPrice.find(p => p.roomId === this.rateplan.id && p.personsCount === this.personsCount);
  },

  hasCleaningPrice: function () {
    if(!Array.isArray(this.addons)){
      return false;
    }

    var obligatoryAddons = this.addons.filter(addon => addon.obligatory);

    return obligatoryAddons && obligatoryAddons.length > 0;
  },

  getAdditionalInfoPrice: function () {
    var obligatoryAddons = this.addons.filter((addon) => addon.obligatory);
    var sumPersons = this.occupancy[0].categoryCount && this.occupancy[0].categoryCount.length ? this.occupancy[0].categoryCount.reduce((accumulator, currentValue) => accumulator + currentValue, this.occupancy[0].count) : this.occupancy[0].count;
    var cleaningPrice = 0;

    for (var i = 0; i < obligatoryAddons.length; i++) {

      switch (obligatoryAddons[i].priceMode) {
        case 4:
          cleaningPrice += parseInt(obligatoryAddons[i].pricePerUnit) * parseInt(obligatoryAddons[i].nights) * parseInt(sumPersons);
        break;
        case 3:
          cleaningPrice += parseInt(obligatoryAddons[i].pricePerUnit) * parseInt(obligatoryAddons[i].nights);
        break;
        case 2:
          cleaningPrice += parseInt(obligatoryAddons[i].pricePerUnit) * parseInt(sumPersons);
        break;

        default:
          cleaningPrice += obligatoryAddons[i].pricePerUnit;
      }
    }

    var formatCleaningPrice = this.Currency.getFormattedPrice(cleaningPrice);
    return this.$translate.instant("offers.item.CLEANING_PRICE", {
      price: formatCleaningPrice,
    });
  },

  getPrice: function () {
    if (this.viewType === 'rates') {
      return this.Currency.getFormattedPrice(this.findRoomPrice().price)
    } else {
      return this.Currency.getFormattedPrice(this.rateplan.prices.price);
    }
  },

  getDiscountPrice: function () {
    if (this.hasDiscountPrice()) {
      if(this.viewType === 'rates'){
        var price = this.findRoomPrice();
        return this.Currency.getFormattedPrice(price.discountPrice);
      }

      return this.Currency.getFormattedPrice(this.rateplan.prices.discountPrice);
    }
    return this.getPrice();
  },

  hasDiscountPrice: function () {
    var prices = this.rateplan.prices;
    if (this.viewType === 'rates') {
      var price = this.findRoomPrice();
      
      if(angular.isDefined(price.discountPrice) && price.discountPrice !== null){
        return price.discountPrice !== price.price;
      }

      return false;
    }

    if (angular.isDefined(prices.discountPrice) && prices.discountPrice !== null) {
      return prices.discountPrice !== prices.price;
    }
    return false;
  },

  isEnabledHostelView: function () {
    return this.ConfigBookingEngine.isHostelViewEnabled();
  },

  setSelectedDorms: function (count) {
    this.selectedDorms = count;
  },

  isClosedToArrival: function () {
    if (this.viewType === 'rates') {
      return this.parent.cta;
    } else {
      return this.rateplan.cta;
    }
  },

  isClosedToDeparture: function () {
    if (this.viewType === 'rates') {
      return this.parent.ctd;
    } else {
      return this.rateplan.ctd;
    }
  },

  hasBreakfasts: function () {
    if (this.viewType === 'rates') {
      return this.parent.breakfast;
    } else {
      return this.rateplan.breakfast;
    }
  },

  hasDinners: function () {
    if (this.viewType === 'rates') {
      return this.parent.dinner;
    } else {
      return this.rateplan.dinner;
    }
  },

  hasLunches: function () {
    if (this.viewType === 'rates') {
      return this.parent.lunch;
    } else {
      return this.rateplan.lunch;
    }
  },

  hasSuppers: function () {
    if (this.viewType === 'rates') {
      return this.parent.supper;
    } else {
      return this.rateplan.supper;
    }
  },

  getMinStay: function () {
    if (this.viewType === 'rates') {
      return this.parent.minStay;
    } else {
      return this.rateplan.minStay;
    }
  },

  getMaxStay: function () {
    if (this.viewType === 'rates') {
      return this.parent.maxStay;
    } else {
      return this.rateplan.maxStay;
    }
  },

  isFulfillMinStay: function () {
    var rateplan;
    if (this.viewType === 'rates') {
      rateplan = this.parent;
    } else {
      rateplan = this.rateplan;
    }
    if (rateplan.minStay !== 0) {
      return this.lengthOfStay >= rateplan.minStay;
    }
    return true;
  },

  isFulfillMaxStay: function () {
    var rateplan;
    if (this.viewType === 'rates') {
      rateplan = this.parent;
    } else {
      rateplan = this.rateplan;
    }

    if (rateplan.maxStay !== 0) {
      return this.lengthOfStay <= rateplan.maxStay;
    }
    return true;
  },

  isAvailable: function () {
    var fulfillMinStay = this.isFulfillMinStay();
    var fulfillMaxStay = this.isFulfillMaxStay();
    var fulfillCta = !this.isClosedToArrival();
    var fulfillCtd = !this.isClosedToDeparture();
    var hasAvailability = this.hasAvailability();

    return hasAvailability && fulfillMinStay && fulfillMaxStay && fulfillCta && fulfillCtd;
  },

  getStayTranslation: function (count) {
    var translations = this.getStayDeclination();

    if (count in translations) {
      return translations[count].replace('%d', count);
    }
    return translations['-1'].replace('%d', count);
  },

  getStayDeclination: function () {
    return {
      1: this.$translate.instant('offers.item.ONE_NIGHT'),
      2: this.$translate.instant('offers.item.TWO_TO_FOUR_NIGHTS'),
      3: this.$translate.instant('offers.item.TWO_TO_FOUR_NIGHTS'),
      4: this.$translate.instant('offers.item.TWO_TO_FOUR_NIGHTS'),
      '-1': this.$translate.instant('offers.item.FIVE_AND_MORE_NIGHTS')
    };
  },

  getAttributes: function () {
    var result = [];
    if (this.hasBreakfasts()) {
      result.push({
        icon: '<i class="fa fa-cutlery" aria-hidden="true"></i>',
        text: this.$translate.instant('offers.item.INCLUDE_BREAKFASTS')
      });
    }
    if (this.hasDinners()) {
      result.push({
        icon: '<i class="fa fa-cutlery" aria-hidden="true"></i>',
        text: this.$translate.instant('offers.item.INCLUDE_DINNERS')
      });
    }
    if (this.hasLunches()) {
      result.push({
        icon: '<i class="fa fa-cutlery" aria-hidden="true"></i>',
        text: this.$translate.instant('offers.item.INCLUDE_LUNCHES')
      });
    }
    if (this.hasSuppers()) {
      result.push({
        icon: '<i class="fa fa-cutlery" aria-hidden="true"></i>',
        text: this.$translate.instant('offers.item.INCLUDE_SUPPERS')
      });
    }
    return result;
  },

  getThumbnail: function () {
    var images = this.rateplan.images;
    if (images.length > 0) {
      const splitStr = images[0].src.split(".");
      return this.ENV.images + splitStr[0] + '-medium.' + splitStr[1];
    }
    return '/be/assets/img/dummy.png';
  },

  getImages: function () {
    return this.rateplan.images;
  },

  openPresentation: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalPresentation',
      size: 'lg',
      resolve: {
        title: function () {
          return $this.getName();
        },
        images: function () {
          return $this.getImages();
        },
        attributes: function () {
          return $this.attributes;
        },
        description: function () {
          return $this.getDescription();
        }
      }
    }).result.then(function () { }, function () { });
  },

  openAvailability: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalRateplanAvailability',
      size: 'lg',
      resolve: {
        groupId: function () {
          return $this.groupId;
        },
        rateplanId: function () {
          return $this.rateplan.id;
        },
        personsCount: function () {
          return $this.personsCount;
        }
      }
    }).result.then(function () { }, function () { });
  }
};
